module.exports = __webpack_public_path__ + "img/icon4.23b8aaa0.png";